import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
`
const InfoRow = styled.div`
  display: flex;
  margin-bottom: 20px;
`;
const InfoLabel = styled.label`
  font-weight: 600;
  margin-right: 8px;
`;

class Account extends React.Component {
  render () {
    const { userData } = this.props;

    return (
      <Container>
        <InfoRow><InfoLabel>Name:</InfoLabel> {userData.name}</InfoRow>
        <InfoRow><InfoLabel>Username:</InfoLabel> {userData.username}</InfoRow>
        <InfoRow><InfoLabel>Email:</InfoLabel> {userData.email}</InfoRow>
      </Container>
    );
  }
};

export default Account;
